var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "container" },
    [
      _c("page-header", { attrs: { title: "Заказы" } }),
      _vm._v(" "),
      _c("Table", {
        attrs: {
          "table-id": "PageOrdersTable",
          "table-config": _vm.tableConfig,
          "table-data": _vm.orders,
          "current-page": _vm.page,
          pages: _vm.totalPages
        },
        on: { "btn-click": _vm.btnClickHandler, request: _vm.onRequestData }
      }),
      _vm._v(" "),
      _c(
        "q-dialog",
        {
          attrs: {
            "content-class": "order-details-dialog",
            value: !!_vm.selectedOrder
          },
          on: { hide: _vm.onDialogHide }
        },
        [
          _c(
            "div",
            { staticClass: "order-details-dialog__content-wrapper" },
            [
              _c("q-btn", {
                directives: [{ name: "close-popup", rawName: "v-close-popup" }],
                staticClass: "order-details-dialog__close-btn",
                attrs: { icon: "close", flat: "", round: "", dense: "" }
              }),
              _vm._v(" "),
              _c("order-details", {
                staticClass: "order-details-dialog__content",
                attrs: { order: _vm.selectedOrder }
              })
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }